//@ts-check
import * as THREE from "three";

/**
 * @module Lights
 */

/**
 *  Creates Directional basic light for the scene 
 * @param {Number} [sunColor = 0xffefdb ] 
 * @param {Number} [intensity = 3.0] 
 */
export function createSunLight(sunColor = 0xffefdb, intensity = 3.0) {
  //Add Directional Light
  this.sunlight = new THREE.DirectionalLight(0xffffff, 1);
  this.sunlight.name = "sceneGround";
  this.sunlight.color.setHex(sunColor)
  this.sunlight.position.set(1, 1, 2);
  this.sunlight.position.multiplyScalar(2048);
  this.sunlight.intensity = intensity;

  this.sunlight.castShadow = this.showShadows;
  this.sunlight.shadow.mapSize.width = 2048;
  this.sunlight.shadow.mapSize.height = 2048;
  this.sunlight.shadow.autoUpdate = false;
  this.sunlight.shadow.needsUpdate = true;

  const d = 50;
  this.sunlight.shadow.camera.left = - d;
  this.sunlight.shadow.camera.right = d;
  this.sunlight.shadow.camera.top = d;
  this.sunlight.shadow.camera.bottom = - d;
  this.sunlight.shadow.camera.near = this.near;
  this.sunlight.shadow.camera.far = 3500;
  this.sunlight.shadow.bias = 0.0001;

  this.lights.push(this.sunlight);
}


/**
 * Creates Basic Lighting for the scene
 */
export function createDefaultLights() {
  this.createSunLight();
  //Add Second Directional Light
  const dirLight = new THREE.DirectionalLight(0xFCF9D9, 0.5);
  dirLight.color.setHex(0xd9f4fc)
  dirLight.position.set(1, -1, 3);
  dirLight.intensity = 2;
  dirLight.position.multiplyScalar(1000);

  dirLight.castShadow = this.showShadows;

  const d = 50;
  dirLight.shadow.camera.left = - d;
  dirLight.shadow.camera.right = d;
  dirLight.shadow.camera.top = d;
  dirLight.shadow.camera.bottom = - d;
  dirLight.shadow.camera.far = 3500;
  dirLight.shadow.camera.near = this.near;
  dirLight.shadow.bias = - 0.0001;

  //this.lights.push(dirLight);
}


/**
 * Add lights to the scene
 */
export function setLights() {
  for (let light of this.lights) {
    this.scene.add(light);
  }
}

/**
 * Sets Light Shadows 
 * @param {boolean} showShadows 
 */
export function setLightShadows(showShadows) {
  this.showShadows = showShadows;
  this.updateShadows();
}

/**
 * Updates Shadows
 */
export function updateShadows() {
  for (let light of this.lights) {
    light.castShadow = this.showShadows;
  }
}
